import type { SelectProps as AntdSelectProps } from "antd";
import { Select as AntdSelect } from "antd";
import React from "react";
import "./style.scss";
import { SelectArrow } from "../../icons";

const { Option } = AntdSelect;

type OptionType = {
  label: string;
  value: string | number;
};

interface SelectProps {
  label?: string;
  options?: OptionType[];
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  popupClassName?: string;
  widthVariant?: "wFull" | "customWidth" | "standard" | "none";
  placeholder?: string;
  customWidthClass?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  mode?: AntdSelectProps["mode"];
  value?: string | number | (string | number)[] | null;
  maxTagCount?: number;
  onChange?: (value: string | number | (string | number)[] | null) => void;
  onSearch?: (value: string) => void;
  handleChange?: (value: string | number | (string | number)[] | null) => void;
  filterOption?: any;
}

const Select: React.FC<SelectProps> = ({
  label,
  options = [],
  className = "",
  labelClassName = "",
  inputClassName = "",
  popupClassName = "",
  widthVariant = "standard",
  placeholder = "Select",
  customWidthClass = "",
  showSearch = true,
  allowClear = true,
  mode,
  value,
  maxTagCount = 2,
  onChange,
  handleChange,
  onSearch,
  filterOption,
}) => {
  const getWidthClass = () => {
    switch (widthVariant) {
      case "wFull":
        return "select-full";
      case "customWidth":
        return customWidthClass;
      case "none":
        return "select-none";
      case "standard":
      default:
        return "select-standard";
    }
  };

  const handleSelectChange = (val: any) => {
    onChange?.(val);
    handleChange?.(val);
  };

  return (
    <div className={`primary-select ${className}`}>
      {label && (
        <label className={`label-text ${labelClassName}`}>{label}</label>
      )}
      <AntdSelect
        value={value}
        mode={mode}
        showSearch={showSearch}
        onSearch={onSearch}
        className={`select-input ${getWidthClass()} ${inputClassName}`}
        popupClassName={popupClassName}
        onChange={handleSelectChange}
        placeholder={placeholder}
        allowClear={allowClear}
        suffixIcon={<SelectArrow />}
        maxTagCount={maxTagCount}
        filterOption={
          filterOption ??
          ((input, option: any) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase()))
        }
        optionFilterProp="label"
        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} more`}
      >
        {options.map((opt) => (
          <Option key={opt.value} value={opt.value} label={opt.label}>
            {opt.label}
          </Option>
        ))}
      </AntdSelect>
    </div>
  );
};

export default Select;
